import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { AccommodationFormService } from 'src/app/trip-calculator/services/accommodation-form.service';
import { PrestationModalService } from 'src/app/trip-calculator/services/prestation-modal.service';
import { ErrorComponent } from '../../error/error.component';
import { SelectAccommodationTypeComponent } from './select-accommodation-type/select-accommodation-type.component';
import { CheckboxModule } from 'primeng/checkbox';
import { ScheduledDaysSelectorComponent } from '../../custom-input/scheduled-days-selector/scheduled-days-selector.component';
import { InputNumberModule } from 'primeng/inputnumber';
import {
  HOTELS,
  PER_ACCOMMODATION,
} from 'src/app/trip-calculator/models/accommodation';
import { SelectCountryComponent } from '../../custom-input/select-country/select-country.component';
import { TripService } from 'src/app/trip-calculator/services/trip.service';
import { SelectCustomAccommodationFactorComponent } from './select-custom-accommodation-factor/select-custom-accommodation-factor.component';

@Component({
  selector: 'app-accommodation-modal',
  imports: [
    ButtonModule,
    TranslocoPipe,
    ReactiveFormsModule,
    InputTextModule,
    ErrorComponent,
    SelectAccommodationTypeComponent,
    CheckboxModule,
    ScheduledDaysSelectorComponent,
    InputNumberModule,
    SelectCountryComponent,
    SelectCustomAccommodationFactorComponent,
  ],
  templateUrl: './accommodation-modal.component.html',
})
export class AccommodationModalComponent {
  prestationModalService = inject(PrestationModalService);
  accommodationFormService = inject(AccommodationFormService);
  tripService = inject(TripService);
  loading: boolean = false;

  submit() {
    this.loading = true;
    this.accommodationFormService.submitAccommodation()?.subscribe({
      next: () => {
        this.loading = false;
        this.revalidateTrip();
        this.close();
      },
      error: () => (this.loading = false),
    });
  }

  /**
   * Trigger re-validation of the trip after successful save
   */
  private revalidateTrip() {
    const trip = this.tripService.trip();
    if (!trip?.id) return;

    this.tripService.triggerValidation(trip.id);
  }
  close() {
    this.prestationModalService.close();
    this.accommodationFormService.resetFormGroup();
  }

  get displayPerRoom() {
    return HOTELS.includes(
      this.accommodationFormService.accommodationForm.get('type')?.value,
    );
  }
  get displayPerAccommodation() {
    return PER_ACCOMMODATION.includes(
      this.accommodationFormService.accommodationForm.get('type')?.value,
    );
  }
  get displayPerPerson() {
    return !this.displayPerAccommodation && !this.displayPerRoom;
  }
}
